import React from "react"

const PER_PAGE_OPTIONS = [10, 25, 50, 100];

const DataPerPage = ({ dataPerPage, setDataPerPage }) => {
    const value = Number(dataPerPage) || PER_PAGE_OPTIONS[0];
    return (
        <>
            <div className="d-flex align-items-baseline">
                <p>Show</p>
                <div className="custom-select-container me-2 ms-2 ali">
                    <select
                        id="custom-select"
                        className="custom-select"
                        value={value}
                        onChange={(e) => setDataPerPage(e.target.value)}
                    >
                        {PER_PAGE_OPTIONS.map((n) => (
                            <option key={n} value={n}>{n}</option>
                        ))}
                    </select>
                </div>
                {/* <p>entries</p> */}
            </div>
        </>
    )
}
export default DataPerPage